import { Text as ShrikeText } from '@perch-labs/shrike';
import styled from 'styled-components';
import {
  color,
  flexbox,
  layout,
  space,
  typography,
  ColorProps,
  FlexboxProps,
  LayoutProps,
  SpaceProps,
  TypographyProps,
} from 'styled-system';

interface TitleAndDescriptionProps extends ColorProps, SpaceProps, TypographyProps {
  margin?: string;
  fontSize?: string;
}
interface TextProps extends TitleAndDescriptionProps, FlexboxProps, LayoutProps {}

export const Title = styled(ShrikeText).attrs({
  tag: 'h1',
  textStyle: 'heading800',
})<TitleAndDescriptionProps>`
  margin: ${props => props.margin || '40px 0 16px'};
  fontsize: ${props => props.fontSize};
  ${color}
  ${space}
  ${typography}

  @media ${props => props.theme.media.tabletLandscapeDown} {
    ${props => !props.margin && 'margin-top: 0;'}
  }
`;

export const Description = styled(ShrikeText)<TitleAndDescriptionProps>`
  margin-bottom: 24px;
  ${color}
  ${space}
  ${typography}
`;

export const Text = styled(ShrikeText)<TextProps>`
  ${flexbox}
  ${layout}
  ${space}
  ${typography}
`;

export const Ul = styled.ul<SpaceProps>`
  list-style: disc outside;
  margin-left: 20px;
  ${space}

  li {
    line-height: 150%;
    font-family: ${props => props.theme.fontFamilies.main.regular};
  }
`;

export const StyledUl = styled(Ul)`
  margin-left: 0px;

  li {
    align-items: flex-start;
    display: flex;

    & * {
      flex-shrink: 0;
    }
  }

  li:not(:first-child):not(:last-child) {
    margin: 16px 0;
  }
`;

export const UlListItem = styled.li<SpaceProps>`
  ${space}
`;

export const UlListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  align-items: center;
`;

export const ReviewItemLogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 5px 0px;
`;
